import React from 'react';
import { useTheme } from '../../../../../../../theme';
import cn from 'classnames';
import Money from '../../../../../../../Money/components/Money';
import { useTranslation } from 'react-i18next';
import PriceInMiles from '../../../../../../../PriceInMiles/PriceInMiles';
const Header = ({ className, title, disabled, price, originalPrice, priceInMiles }) => {
    const { t } = useTranslation('FareGroup');
    const { Header: css } = useTheme('Entities').FareGroupV2;
    const showMiles = !disabled && priceInMiles;
    const showPrice = !disabled && !priceInMiles;
    const showOriginalPrice = !!originalPrice && originalPrice.amount !== price.amount;
    return (React.createElement("div", { className: cn(css.root, className) },
        React.createElement("div", { className: css.title }, title),
        React.createElement("div", { className: css.right },
            disabled && React.createElement("span", { className: css.unavailable }, t('Unavailable')),
            showMiles && (React.createElement(PriceInMiles, { moneyClassName: css.miles, amountClassName: css.miles__amount, amount: priceInMiles })),
            showPrice && (React.createElement("div", { className: css.priceWrapper },
                React.createElement(Money, { moneyClassName: css.price, money: price }),
                showOriginalPrice && React.createElement(Money, { moneyClassName: css.originalPrice, money: originalPrice }))))));
};
export default Header;
